<template>
    <div class="info-section-margins d-flex flex-column">
    <div class="d-flex flex-row pointer" @click="showDish()">
      <div class="f17-l19-m flex-grow-1 two-lines-on-carousel two-lines-on-search text-truncate-on-carousel" style="height:40px;max-height:40px;word-break:break-word;white-space: break-spaces;">{{dish.sections.title.text}}</div>
      <div class="text-left " style="min-width:30%;">
        <div class="d-flex flex-row f17-l19-m" dir="rtl">
          <div class="flex-grow-1"></div>
          <PriceComponent v-if="dish.price_options.about_price.display.discounted" class="stroke margin-space-after" :value="dish.price_options.about_price.display.nominal_price" />
          <PriceComponent :value="dish.price_options.about_price.display.price || dish.price_options.about_price.display.unit_price" />
        </div>
        <div class="f14-l18 red">{{dish.price_options.about_price.display.text}}</div>
        <div class="f14-l18">{{dish.price_options.about_price.display.min_amount_text}}</div>
        <div class="f14-l18">{{dish.price_options.about_price.display.content_text}}</div>
      </div>
    </div>
    <div class="f14-l18 red bold text-truncate-on-carousel one-line-on-desktop one-line-on-tablet">{{dish.sections.subtitle.text || ``}}</div>
    <div class="f14-l18 red bold one-line-on-carousel one-line-on-search text-truncate-on-carousel one-line-on-desktop one-line-on-tablet" v-html="dish.sections.subtitle.price_preview || ``"></div>
    <div v-if="dish.sections.description" :class="calcDescriptionClass()">
      <ReadMore :text="dish.sections.description.text_html" :moreText="dish.sections.description.more_text.text" :disableDesktopMode="true" :lines="6" highView />
    </div>
    <div class="text-center line-height-05 save-space-25 ">
      <span class="f13-l16-l" v-for="(p,pkey) in dish.sections.dishes_filter_tags" :key="pkey">{{p.text}}<span v-if="pkey<Object.keys(dish.sections.dishes_filter_tags).length-1" class="red strong"> | </span> </span>
    </div>
    <div class="d-flex text-center f14-l19 justify-content-center align-items-center strong availability-line-margin one-line-on-desktop one-line-on-tablet">
      <span class="tf11-l13">{{ dish.sections.availability.availability_line }}</span>
    </div>
    <!-- <div v-if="dish.sections.dishes_filter_tags" class="margin-top-20 save-space-48">
      <DishPreferenceComponent v-for="p in dish.sections.dishes_filter_tags" :preference="p" :key="p.search_url" />
    </div> -->
  </div>

</template>
<script>
  import ReadMore from "@/components/generic/ReadMore.vue";
  import PriceComponent from "@/components/generic/PriceComponent.vue";
  export default {
    components: {
      // DishPreferenceComponent,
      ReadMore,
      PriceComponent,
    },
    props: {
      dish: Object,
      menuView: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      showDish() {
        this.$router.push(this.dish.url);
        // this.$store.dispatch('fetchDish', this.dish.url);
        // let offcanvas = document.getElementById("offcanvasExample");
        // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
        // bsOffcanvas.show();
      },
      calcDescriptionClass(){
        const lines = this.menuView ? 'eight' : 'three'

        return `f14-l18-l text-break two-lines-on-carousel ${ lines }-lines-on-desktop  ${ lines }-lines-on-tablet deal-preview`
      }
    }
  }
</script>
<style scoped>
  .availability-line-margin {
    margin: 10px 20px 0px 20px;
  }
  .info-section-margins {
    margin: 20px 20px 0px 20px;
  }
</style>
